import verificationLevelUpdateService from '../../services/subscriptions/verificationLevelUpdateService';
import { closeKYCSidePane } from './sidePaneActions';
import { kycLevelFormSelector } from '../selectors/kycLevelsSelectors';
import { findIndexOfObject } from '../../helpers/arrayHelper';
export var UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';
export var USER_CONFIG_UPDATED = 'USER_CONFIG_UPDATED';
export var PROCESSING_VALIDATE_USER_REGISTRATION = 'PROCESSING_VALIDATE_USER_REGISTRATION';
export var FINISHED_VALIDATE_USER_REGISTRATION = 'FINISHED_VALIDATE_USER_REGISTRATION';
export var processingValidateUserRegistration = {
  type: PROCESSING_VALIDATE_USER_REGISTRATION
};
export var finishedValidateUserRegistration = {
  type: FINISHED_VALIDATE_USER_REGISTRATION
};
export var updateAccount = function updateAccount(payload) {
  return {
    type: UPDATE_ACCOUNT,
    payload: payload
  };
};
export var userConfigUpdated = function userConfigUpdated(payload) {
  return {
    type: USER_CONFIG_UPDATED,
    payload: payload
  };
};
export var updateUserConfig = function updateUserConfig(userConfigUpdatedPayload) {
  var closeSidePane = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function (dispatch) {
    dispatch(userConfigUpdated(userConfigUpdatedPayload));
    if (closeSidePane) dispatch(closeKYCSidePane());
  };
};
export var subscribeToVerificationLevelUpdateEvents = function subscribeToVerificationLevelUpdateEvents(state) {
  return function (dispatch) {
    var stateItem = Object.assign({}, state);
    verificationLevelUpdateService.subscribe(function (update) {
      stateItem.VerificationLevel = update.VerificationLevel;
      var payload = {
        index: 0,
        item: stateItem
      };
      dispatch(updateAccount(payload));
    });
  };
};
export var temporarilySetLevelIncreaseStatus = function temporarilySetLevelIncreaseStatus(_ref) {
  var levelIncreaseStatus = _ref.levelIncreaseStatus;
  return function (dispatch, getState) {
    var _kycLevelFormSelector = kycLevelFormSelector(getState()),
      userConfig = _kycLevelFormSelector.userConfig;
    var levelIncreaseStatusIndex = findIndexOfObject(userConfig, 'Key', 'levelIncreaseStatus');
    var setLevelIncreaseStatusPayload = {
      index: levelIncreaseStatusIndex,
      item: {
        Key: 'levelIncreaseStatus',
        Value: levelIncreaseStatus
      }
    };
    dispatch(updateUserConfig(setLevelIncreaseStatusPayload, false));
  };
};